<div class="ion-text-center alert-content">
  <custom-icon
    *ngIf="icon"
    [iconName]="icon"
    [width]="70"
    [height]="70"
    colorClass="modalIcon"
  ></custom-icon>
  <img *ngIf="img" [src]="img" />
  <h3 *ngIf="heading" class="fs-5 font600 modal-primary-text-color">
    {{ heading }}
  </h3>
  <div class="ion-margin-vertical">
    <p
      class="fs-4 font400 modal-secondary-text-color ion-no-margin"
      *ngIf="message"
      [innerHTML]="message"
    ></p>
    <p
      class="fs-4 font400 modal-secondary-text-color ion-no-margin"
      *ngIf="message2"
      [innerHTML]="message2"
    ></p>
  </div>
  <div *ngIf="isPrompt">
    <ion-grid fixed>
      <ion-row>
        <ion-col size="6">
          <ion-button
            (click)="handlePostiveResponse()"
            mode="ios"
            [class]="isUpgrade ? 'primary-btn' : 'outline-btn'"
            expand="block"
          >
            {{
              yesBtnText ? yesBtnText : ("modals.generic_alert.yes" | translate)
            }}
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button
            (click)="handleNegativeResponse()"
            mode="ios"
            [class]="isUpgrade ? 'outline-btn' : 'primary-btn'"
            expand="block"
          >
            {{
              noBtnText ? noBtnText : ("modals.generic_alert.no" | translate)
            }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <div *ngIf="!isPrompt && !isCancelBooking && !cancelBookingV2" class="mart30">
    <ion-button
      (click)="handleOkayResponse()"
      mode="ios"
      class="mart10 primary-btn"
      expand="block"
    >
      {{
        okayBtnText ? okayBtnText : ("modals.generic_alert.okay" | translate)
      }}
    </ion-button>
    <p
      *ngIf="notMeText || notMeActionText"
      (click)="handleNotMeResponse()"
      class="fs-3 font500 mart20 ion-no-margin not-me-row mart10"
    >
      <span *ngIf="notMeText" class="not-me-prefix font400">{{ notMeText }}</span>
      <span *ngIf="notMeActionText" class="not-me-action font600">{{
        notMeActionText
      }}</span>
    </p>
  </div>
  <div *ngIf="isCancelBooking" class="mart30">
    <ion-button
      (click)="handlePostiveResponse()"
      mode="ios"
      class="mart10 primary-btn"
      expand="block"
    >
      {{ "modals.generic_alert.cancel_booking" | translate }}
    </ion-button>
  </div>
  <div *ngIf="cancelBookingV2" class="mart30">
    <div>
      <ion-button
        (click)="handlePostiveResponse()"
        mode="ios"
        class="outline-btn marb10 cancel-btn"
        expand="block"
      >
        {{ yesBtnText ? yesBtnText : ("modals.generic_alert.yes" | translate) }}
      </ion-button>

      <ion-button
        (click)="handleNegativeResponse()"
        mode="ios"
        class="primary-btn"
        expand="block"
      >
        {{ noBtnText ? noBtnText : ("modals.generic_alert.no" | translate) }}
      </ion-button>
    </div>
  </div>
</div>
